"use client";

import { ExpertiseIconGlyph, type ExpertiseIconKey } from "../../expertise-icons-dathacons";

export interface ServicesSectionDathaconsExpertiseItem {
  title: string;
  description: string;
  icon: ExpertiseIconKey;
}

export interface ServicesSectionDathaconsExpertiseProps {
  sectionId?: string;
  /** Mặc định design FullWidth */
  heading?: string;
  items: ServicesSectionDathaconsExpertiseItem[];
}

function chunk<T>(arr: T[], size: number): T[][] {
  const out: T[][] = [];
  for (let i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size));
  return out;
}

export default function ServicesSectionDathaconsExpertise({
  sectionId = "expertise",
  heading = "Năng lực chuyên môn",
  items,
}: ServicesSectionDathaconsExpertiseProps) {
  const rows = chunk(items, 3);

  return (
    <div
      id={sectionId}
      className="bg-white content-stretch flex flex-col items-center justify-center overflow-clip py-10 md:py-[100px] relative shrink-0 w-full"
      data-name="Expertise section"
    >
      <div
        className="content-stretch flex flex-col gap-0 md:gap-[40px] items-stretch md:items-center justify-center relative shrink-0 w-[1120px] max-w-[min(1120px,calc(100%-32px))] px-4 md:px-5"
        data-name="Expertise Container max-width 1120px"
      >
        <p className="font-extrabold leading-[1.15] md:leading-[60px] not-italic relative shrink-0 text-[#ffa411] text-[28px] sm:text-[32px] md:text-[47px] w-full text-left">
          {heading}
        </p>

        <div className="mt-6 md:hidden w-full h-px shrink-0 bg-[#e8e8e8]" aria-hidden />

        <div className="flex md:hidden flex-col w-full mt-8 gap-12">
          {items.map((item, i) => (
            <div
              key={`${item.title}-${i}`}
              className="flex flex-col items-start gap-5 max-md:hover:transform-none max-md:hover:!translate-y-0"
              data-name="Expertise item"
            >
              <div className="flex flex-col gap-3 items-start w-full text-left text-[#303030]">
                <p className="font-bold text-[17px] leading-snug">{item.title}</p>
                <p className="font-normal text-[15px] leading-[23px] text-[#1c1c28] w-full">
                  {item.description}
                </p>
              </div>
              <div className="shrink-0 scale-[0.875] origin-left">
                <ExpertiseIconGlyph name={item.icon} />
              </div>
            </div>
          ))}
        </div>

        <div
          className="hidden md:block w-full border-collapse border border-[#e3e3e3]"
          data-name="Expertise details container Expertise cards container"
        >
          <table className="w-full border-collapse">
            <tbody>
              {rows.map((row, ri) => (
                <tr key={ri}>
                  {row.map((item, ci) => (
                    <td
                      key={`${item.title}-${ci}`}
                      className="align-top border border-[#e3e3e3] p-6 min-h-[266px] w-[33.33%]"
                      data-name="Expertise item"
                    >
                      <div
                        className="content-stretch flex flex-col gap-[30px] items-start not-italic relative w-full"
                        data-name="Expertise content"
                      >
                        <div
                          className="content-stretch flex flex-col gap-4 items-start relative shrink-0 text-[#303030] w-full"
                          data-name="Item description container"
                        >
                          <p className="font-bold leading-[normal] relative shrink-0 text-[20px]">
                            {item.title}
                          </p>
                          <p className="font-normal leading-[23px] relative shrink-0 text-[#1c1c28] text-[15px] w-full max-w-none">
                            {item.description}
                          </p>
                        </div>
                        <ExpertiseIconGlyph name={item.icon} />
                      </div>
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

ServicesSectionDathaconsExpertise.displayName = "ServicesSectionDathaconsExpertise";
